export { Divider } from './divider';
export type { DividerProps, DividerStylesNames } from './divider';
export type { DividerStylesParams } from './divider.styles';
